import { Bank } from '../enums/bank.enum';

export interface BankStyle {
  gradient: string;
  iconPath: string;
  buttonIconPath: string;
  name: string;
  iconWidth: number;
  iconHeight: number;
  buttonIconWidth: number;
  buttonIconHeight: number;
  iconHasOwnBackground?: boolean;
}

// @ts-ignore
export const SQ_DEEPLINKS_BANK_STYLES: Record<
  Bank,
  { background: string; iconPath: string; textColor?: string }
> = {
  [Bank.Sberbank]: {
    background: '#21a038',
    iconPath: 'deeplinks/sq/sberbank.svg',
  },
  [Bank.Tinkoff]: {
    background: '#ffdd2d',
    iconPath: 'deeplinks/sq/tinkoff.svg',
    textColor: '#000000',
  },
  [Bank.VTB]: {
    background: '#005BFF',
    iconPath: 'deeplinks/sq/vtb.svg',
  },
  [Bank.Alfa]: {
    background: '#EE3022',
    iconPath: 'deeplinks/sq/alfa.svg',
  },
  [Bank.Ozon]: {
    background: '#005BFF',
    iconPath: 'deeplinks/sq/ozon.svg',
  },
};

export const DEFAULT_SQ_DEEPLINK_STYLE = {
  border: '2px solid #d1d5db',
  background: '#f9fafb',
};

// @ts-ignore
// set up styles for particular banks
export const BANK_STYLES: Record<Bank, BankStyle> = {
  [Bank.Sberbank]: {
    gradient: 'linear-gradient(180deg, #80cb67 0%, #67cdb0 100%)',
    iconPath: 'deeplinks/sber-pay-icon.svg',
    buttonIconPath: 'deeplinks/sber-pay-button-icon.svg',
    name: 'SberPay',
    iconWidth: 70,
    iconHeight: 25,
    buttonIconWidth: 159,
    buttonIconHeight: 22,
  },
  [Bank.Tinkoff]: {
    gradient: 'linear-gradient(180deg, #FFDD2D 0%, #FFE874 100%)',
    iconPath: 'deeplinks/tbank-pay-icon.svg',
    buttonIconPath: 'deeplinks/tbank-pay-button-icon.svg',
    name: 'T-Pay',
    iconWidth: 104,
    iconHeight: 45,
    buttonIconWidth: 329,
    buttonIconHeight: 54,
    iconHasOwnBackground: true,
  },
  [Bank.VTB]: {
    gradient: 'linear-gradient(180deg, #0088CC 0%, #0066AA 100%)',
    iconPath: 'deeplinks/vtb-pay-icon.svg',
    buttonIconPath: 'deeplinks/vtb-pay-button-icon.svg',
    name: 'VTB Pay',
    iconWidth: 104,
    iconHeight: 45,
    buttonIconWidth: 329,
    buttonIconHeight: 54,
    iconHasOwnBackground: true,
  },
  [Bank.Alfa]: {
    gradient: 'linear-gradient(180deg, #EF3124 0%, #D62516 100%)',
    iconPath: 'deeplinks/alfa-pay-icon.svg',
    buttonIconPath: 'deeplinks/alfa-pay-button-icon.svg',
    name: 'Alfa Pay',
    iconWidth: 104,
    iconHeight: 45,
    buttonIconWidth: 329,
    buttonIconHeight: 54,
    iconHasOwnBackground: true,
  },
  [Bank.Ozon]: {
    gradient: 'linear-gradient(180deg, #005BFF 0%, #0041CC 100%)',
    iconPath: 'deeplinks/ozon-pay-icon.svg',
    buttonIconPath: 'deeplinks/ozon-pay-button-icon.svg',
    name: 'Ozon Pay',
    iconWidth: 104,
    iconHeight: 45,
    buttonIconWidth: 329,
    buttonIconHeight: 54,
    iconHasOwnBackground: true,
  },
};
